/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Home_OfficialInputs */



/**
* | output |
* | --- |
* | "The official VTES Discord" |
*
* @param {Tournament_Wiz_Home_OfficialInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_home_official = /** @type {((inputs?: Tournament_Wiz_Home_OfficialInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Home_OfficialInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le Discord officiel VTES")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Discord oficial de VTES")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O Discord oficial de VTES")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il Discord ufficiale di VTES")
	return /** @type {LocalizedString} */ ("The official VTES Discord")
});